export default "__VITE_ASSET__ye8Ocbre__"